module.exports = __webpack_public_path__ + "fonts/Outfit-Light.905f109c.ttf";